// Transcript servis fonksiyonları (mevcut backend endpointlerine uygun)

export async function getNewTranscriptStatus(videoId: string, language: string = 'tr') {
  const response = await fetch(`/api/transcripts/status?videoId=${videoId}&language=${language}`);
  if (!response.ok) {
    throw new Error(`Status API error: ${response.status} ${response.statusText}`);
  }
  return await response.json();
}

export async function createNewTranscript(videoId: string, language: string = 'tr') {
  const response = await fetch('/api/transcripts/from-video', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ videoId, language })
  });
  if (!response.ok) {
    throw new Error(`Create API error: ${response.status} ${response.statusText}`);
  }
  return await response.json();
}

export async function getNewTranscript(videoId: string, language: string = 'tr') {
  const response = await fetch(`/api/transcripts/video/${videoId}?language=${language}`);
  if (!response.ok) {
    throw new Error(`Get API error: ${response.status} ${response.statusText}`);
  }
  return await response.json();
} 